var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.displayClass)?_c('i',{class:{'icon': true, [_vm.displayClass]: true, [_vm.iconSize]: true}}):_vm._e(),_vm._v(" "+_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }